import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className: 'flex flex-col items-center gap-40 m:items-start'
});

export const HeadingWrapper = createComponent('div', {
  className: 'flex flex-col items-start gap-8'
});

export const GridWrapper = createComponent('div', {
  className: 'grid grid-cols-1 gap-16 md:grid-cols-2 lg:grid-cols-4'
});
